const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.sessionProvider.timeoutComponent.';

const TITLE = `${DOMAIN}title`,
  DESCRIPTION = `${DOMAIN}description`,
  BACK_TO_MERCHANT = `${DOMAIN}backToMerchant`;

export { BACK_TO_MERCHANT, DESCRIPTION, TITLE };
